import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PagesIcon from '@mui/icons-material/Pages';
import { Box, Divider, Grid, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import ManageGroupExternalPricelistPermissions from './ManageGroupExternalPricelistPermissions';
import ManageGroupPagePermissions from './ManageGroupPagePermissions';
import ManageGroupPricelistPermissions from './ManageGroupPricelistPermissions';

const listItems = [
    { name: 'Pages', icon: <PagesIcon /> },
    { name: 'Pricelists', icon: <AttachMoneyIcon /> },
    { name: 'Ext. pricelists', icon: <AttachMoneyIcon /> }
];

export const ManageGroupPermissions = () => {
    const [listItemIndex, setListItemIndex] = useState(0);

    const handleSetSelectedListItem = (listItemIdx: number) => {
        setListItemIndex(listItemIdx);
    };

    return (
        <Grid sx={{ flexFlow: 'row' }} container>
            <Grid item xs={2}>
                <List dense>
                    {listItems.map((li, idx) => (
                        <ListItem
                            button
                            key={idx}
                            onClick={() => handleSetSelectedListItem(idx)}
                            selected={idx === listItemIndex}
                        >
                            <ListItemIcon>{li.icon}</ListItemIcon>
                            <ListItemText>{li.name}</ListItemText>
                        </ListItem>
                    ))}
                </List>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item xs={10} sx={{ paddingLeft: '10px' }}>
                <Box p={2}>
                    {listItemIndex === 0 && <ManageGroupPagePermissions />}
                    {listItemIndex === 1 && <ManageGroupPricelistPermissions />}
                    {listItemIndex === 2 && <ManageGroupExternalPricelistPermissions />}
                </Box>
            </Grid>
        </Grid>
    );
};
